import { SVGProps } from "react"
const LinkedinIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="currentColor" viewBox="0 0 25 24" height="100%" width="100%" {...props}>
    <path d="M5.627 7.197a2.188 2.188 0 1 0 0-4.376 2.188 2.188 0 0 0 0 4.376ZM9.881 8.855v12.139h3.769V14.99c0-1.584.298-3.118 2.262-3.118 1.937 0 1.961 1.81 1.961 3.218v5.904h3.771v-6.657c0-3.27-.704-5.783-4.526-5.783-1.835 0-3.065 1.007-3.568 1.96h-.051v-1.66H9.881Zm-6.142 0h3.775v12.139H3.739V8.854Z" />
  </svg>
)
export default LinkedinIcon
